/**
 * Simple hash function for creating compact hashes of strings
 * Uses a basic djb2-style hash algorithm
 */
export function simpleHash(str: string): string {
	let hash = 0;
	for (let i = 0; i < str.length; i++) {
		const char = str.charCodeAt(i);
		hash = (hash << 5) - hash + char;
		hash = hash & hash; // Convert to 32bit integer
	}
	return hash.toString(36); // Base36 for shorter representation
}

/**
 * Create a hash of a JSON-serializable object
 * Useful for detecting changes in complex objects without storing the full serialized form
 */
export function hashObject(obj: unknown): string {
	return simpleHash(JSON.stringify(obj));
}
